












































































































import Vue from 'vue';

export default Vue.extend({
  name: 'HMAudioFileSelector',
  props: {
    value: {
      type: File,
      default: null,
    },
    inputName: {
      type: String,
      default: 'audio-upload',
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'normal',
    },
  },
  data() {
    return {
      inputValue: null,
      error: null,
      isUploading: false,
      showDropdown: false,
      isDragging: false,
      reader: new FileReader(),
    };
  },
  computed: {
    status() {
      if (this.isDragging) {
        return 'dragging';
      } else if (this.isUploading) {
        return 'uploading';
      } else if (this.value || this.src) {
        return 'uploaded';
      } else {
        return 'add';
      }
    },
    audioSrc() {
      return URL.createObjectURL(this.value);
    },
  },
  methods: {
    async onFile(inputFile) {
      if (!inputFile) return;
      this.isUploading = true;
      this.reader.readAsDataURL(inputFile);
      this.reader.onloadend = async evt => {
        if (evt.target.readyState == 2) {
          this.updateFile(inputFile);
          this.isUploading = false;
        }
      };
    },
    onChange(e) {
      const file = e.target.files[0];
      this.$refs.inputFile.value = null;
      this.onFile(file);
    },
    drop: function (event) {
      event.stopPropagation();
      event.preventDefault();
      this.isDragging = false;
      const file = event.dataTransfer.files[0];
      this.onFile(file);
    },
    updateFile(file) {
      this.$emit('input', file);
    },
    dragging() {
      this.isDragging = true;
    },
    draggingStop() {
      this.isDragging = false;
    },
    async remove() {
      this.isUploading = true;
      const file = null;
      this.$emit('input', file);
      this.isUploading = false;
    },
  },
});
